module.exports = __webpack_public_path__ + "static/img/term_library_download_single.fa1bf958.gif";